// Module
var code = "<div class=\"visible-selected has-select condensed remove-top-padding clearfix\" ng-show=\"row.labels.length\">\n    <div class=\"assignment-tags\">\n        <span class=\"tag\" ng-repeat=\"label in row.labels\" ng-bind=\"label\"></span>\n    </div>\n</div>\n";
// Exports
module.exports = code;